import React, { useState } from 'react';
import { FileSearch, TrendingUp, Home, Wallet, MessageCircle } from 'lucide-react';

interface FooterNavLayout6Props {
  colors: {
    background: string;
    text: string;
    activeBackground: string;
    activeText: string;
    icon: string;
  };
}

const FooterNavLayout6: React.FC<FooterNavLayout6Props> = ({ colors }) => {
  const navItems = [
    { icon: FileSearch, label: 'History' },
    { icon: TrendingUp, label: 'All Bids' },
    { icon: Home, label: 'Home' },
    { icon: Wallet, label: 'Wallet' },
    { icon: MessageCircle, label: 'Chat' }
  ];

  const [activeIndex, setActiveIndex] = useState<number>(2);

  return (
    <div className="relative w-full">
      {/* Main Navigation Bar */}
      <div 
        className="flex items-center justify-around py-3 px-4 rounded-2xl shadow-md relative"
        style={{ backgroundColor: colors.background }}
      >
        {navItems.map((item, index) => {
          const isActive = index === activeIndex;
          
          return (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className="flex flex-col items-center relative flex-1"
            >
              {isActive ? (
                // Active state: Circle with icon and label inside, with gradient and green glow
                <>
                  {/* Circle that protrudes upward with gradient and green glow */}
                  <div 
                    className="w-16 h-16 rounded-full flex flex-col items-center justify-center shadow-lg -mt-8 relative"
                    style={{ 
                      background: `linear-gradient(135deg, ${colors.activeBackground} 0%, ${colors.activeBackground}dd 100%)`,
                      boxShadow: `0 4px 16px ${colors.activeBackground}60, 0 0 0 2px ${colors.activeBackground}40`
                    }}
                  >
                    <item.icon 
                      className="w-6 h-6 mb-0.5" 
                      style={{ color: colors.activeText }}
                    />
                    {/* Text inside the circle in white */}
                    <span 
                      className="text-[10px] font-medium leading-tight"
                      style={{ color: colors.activeText }}
                    >
                      {item.label}
                    </span>
                  </div>
                </>
              ) : (
                // Inactive state: Icon above, text below (both in white)
                <>
                  <item.icon 
                    className="w-5 h-5 mb-1" 
                    style={{ color: colors.icon }}
                  />
                  <span 
                    className="text-xs font-medium"
                    style={{ color: colors.text }}
                  >
                    {item.label}
                  </span>
                </>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FooterNavLayout6;
